import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { addFirstCardDescription, 
        popupChange, 
        popUpMenuChange,
        selectedCardsGroupsChange, 
        toggleSwitch,
        setActiveTab } from '../../actions/index'

import OnStageLogo from './logo';
import ViewButton from './viewButton';
import ReleaseButton from './releaseButton';
import SignButton from './signButton';
import DeleteButton from './deleteButton';
import AddProgressButton from './addProgressButton';
import UpdateButton from './updateButton';
import StandByButton from './standByButton';
import CyclesButton from './cycles/cyclesButton';
import ReopenButton from './reopenButton';
import EnlargeTunnelButton from './enlargeTunnelButton';
import AddCardsGroupsButton from './addCardsGroupsButton';
import CardsGroupsList from '../popUpCardsGroups/cardsGroupsList';

import { checkFailuresSelected, checkTunnelConditions, groupCardsGroupIds } from '../../functions/cardsGroupsFeatures';
    
import { setButtonPositions } from '../../functions/popUpMenu/visibiltyFunctions';
import { _ } from '../../functions/translator';
import MaterialsInfo from './materialsInfo';
import { CardsGroupStatus, ToggleActions } from '../../constants/constants';
import { postData } from '../../functions/postData';
import ChangeCategoryButton from './adminButtons/changeCategoryButton';
import ChangeLevelButton from './adminButtons/changeLevelButton';
import AddCostsButton from './adminButtons/addCostsButton';
import ExportCertificatesButton from './exportCertificatesButton';
import ExportObservationsButton from './exportObservationsButton';
import ExportRegistersButton from './exportRegistersButton';
import AssignUsersButton from './assignUsersButton';
import AddPaymentButton from './addPaymentButton';
import UpButton from './navigation/upButton';
import DownButton from './navigation/downButton';
import { getCustomCardButtons } from '../../functions/popUpMenu/buttonsToRender';
import ExportObservationsPdfButton from './exportObservationsPdfButton';
import TunnelSubdivisionsButton from './adminButtons/tunnelSubdivisionsButton';
import UnfulfilledButton from './unfulfilledButton';
import GanttChartDatesButton from './ganttChartDatesButton';

class PopUpMenu extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            animationTime: 900
        }
    }

    handleClosePopup = () => {
        if (this.props.popup !== 'none') {
            this.props.popupChange('none')
        } else if (this.props.popUpMenu.expanded) {
            this.props.popUpMenuChange({ show: true, expanded: false })
        } else { 
            this.props.popUpMenuChange({ 
                show: false, 
                close: false, 
                closeList: false,
                expanded: false,
                opacity: 1,
                cyclesButton: false,
                changeMenuButton: false,
            })
            this.props.selectedCardsGroupsChange('none')
        }
    };

    handleAnimationClosePopup = () => {
        this.background.classList.remove('circle-background-animation')
        this.props.popUpMenuChange({ 
            close: true,
            closeList: true,
            opacity: 1
        })
        setTimeout(() => {
            this.handleClosePopup()
        }, this.state.animationTime)
    };

    loadFailureDescriptions = async (cardsGroupIds) => {
        let loadIsNeeded = false;
        for (const cardsGroupId of cardsGroupIds) {
            const cardsGroupData = this.props.projectData.cards_groups[cardsGroupId];
            if (!cardsGroupData.attributes.hasOwnProperty('first_card_description')) {
                loadIsNeeded = true;
            }
        }
        if (!loadIsNeeded) return;
        try {
            let url = '/web-api/get-cards-groups-first-card-description';
            let urlContent = {
                project_id: window.project_id,
                cards_group_ids: cardsGroupIds
            }
            this.props.toggleSwitch(ToggleActions.CARDS_LOADING)
            let result = await postData(url, urlContent);
            if (result.status === 'success') {
                this.props.addFirstCardDescription(result.descriptions);
            }
            this.props.toggleSwitch(ToggleActions.CARDS_LOADING)
        } catch (error) {
            console.log('error al cargar las descripciones de los registros de formularios con falla.', error);
        }
    }

    componentDidUpdate() {
        if (this.props.popUpMenu.close) return
        if (this.background && !this.background.classList.contains('circle-background-animation')) {
            this.background.classList.add('circle-background-animation')
        }
    }
          
    getButtonsToRender = (cardsGroupIds, groupedCardsGroupIds) => {
        const buttons = [];
        let hasSecondActiveTabPermissions = this.props.userRole.admin 
            || this.props.userRole.add_progress_update 
            || this.props.userRole.add_card 
            || this.props.userRole.lineal 
            || this.props.userRole.lineal.delete_card
        
        const closableCardsGroups = groupedCardsGroupIds[CardsGroupStatus.OPEN].concat(
            groupedCardsGroupIds[CardsGroupStatus.IN_PROGRESS],
            groupedCardsGroupIds[CardsGroupStatus.WITH_NO_CONFORMITIES],
            groupedCardsGroupIds[CardsGroupStatus.CLOSED]
        );
        const passTunnelConditions = checkTunnelConditions(cardsGroupIds, this.props.projectData);

        if ((this.props.activeTab === 0 || this.props.activeTab === 1)) {
            buttons.push(<ViewButton/>)
        }

        if (this.props.userRole.admin && this.props.activeTab === 2) {
            buttons.push(<ChangeCategoryButton cardsGroupIds={cardsGroupIds}/>)
            buttons.push(<ChangeLevelButton cardsGroupIds={cardsGroupIds}/>)
        }
        if (this.props.userRole.add_progress_update && this.props.activeTab === 2) {
            buttons.push(<AddCostsButton></AddCostsButton>)
        }
        if (groupedCardsGroupIds[CardsGroupStatus.STAND_BY].length && this.props.userRole.add_card && (this.props.activeTab === 0 || this.props.activeTab === 1)) {
            buttons.push(<ReleaseButton standByCardsGroups={groupedCardsGroupIds[CardsGroupStatus.STAND_BY]}/>);
        }
        if (this.props.userRole.update_card 
            && (groupedCardsGroupIds.separable.length > 0 || groupedCardsGroupIds.mergeable.cardsGroupIds.length > 1) && (this.props.activeTab === 0 || this.props.activeTab === 1)) {
            buttons.push(<CyclesButton separableCardsGroups={groupedCardsGroupIds.separable} mergeableCardsGroups={groupedCardsGroupIds.mergeable}/>);
        }
        if (this.props.userRole.batch_update_card && this.props.userRole.update_card && groupedCardsGroupIds.equalProtocols && closableCardsGroups.length > 0 && (this.props.activeTab === 0 || this.props.activeTab === 1)) {
            buttons.push(<UpdateButton closableCardsGroups={closableCardsGroups}/>);
        }
        if (this.props.userRole.add_progress_update && (this.props.activeTab === 0 || this.props.activeTab === 1)) {
            buttons.push(<AddProgressButton cardsGroupIds={cardsGroupIds}/>);
        }
        
        if (groupedCardsGroupIds[CardsGroupStatus.OPEN].length && this.props.userRole.add_card && (this.props.activeTab === 0 || this.props.activeTab === 1)) {
            buttons.push(<StandByButton cardsGroupIds={groupedCardsGroupIds[CardsGroupStatus.OPEN]}/>);
        }
        if (closableCardsGroups.length && this.props.userRole.batch_close && this.props.userRole.sign_revision  && (this.props.activeTab === 0 || this.props.activeTab === 1)) {
            buttons.push(<SignButton closableCardsGroups={closableCardsGroups}/>);
        }
        // if (this.props.userRole.edit_protocol && groupedCardsGroupIds.equalCategories && this.props.activeTab === 2) {
        //     buttons.push(<AddCardsGroupsButton cardsGroupIds={cardsGroupIds}/>);
        // }
        if (this.props.userRole.add_card && groupedCardsGroupIds.closedSelectedOnly && (this.props.activeTab === 0 || this.props.activeTab === 1)) {
            buttons.push(<ReopenButton closedCardsGroupIds={groupedCardsGroupIds[CardsGroupStatus.CLOSED]}/>);
        }

        if (this.props.userRole.add_card && this.props.userRole.lineal && passTunnelConditions && this.props.activeTab === 2) {
            buttons.push(<EnlargeTunnelButton cardsGroupIds={cardsGroupIds}/>);
        }

        if (this.props.userRole.admin && cardsGroupIds.length === 1 && this.props.activeTab === 2) {
            buttons.push(<TunnelSubdivisionsButton/>);
        }

        if (this.props.userRole.delete_card  && this.props.activeTab === 2) {
            buttons.push(<DeleteButton cardsGroupIds={cardsGroupIds}/>);
        }
        let customCardButtons = getCustomCardButtons(this.props.projectData)
        if (customCardButtons.length === 0) {
            if(this.props.activeTab === 3) {
                buttons.push(<ExportObservationsButton></ExportObservationsButton>)
                buttons.push(<ExportRegistersButton></ExportRegistersButton>)
                buttons.push(<ExportCertificatesButton></ExportCertificatesButton>)
                buttons.push(<ExportObservationsPdfButton></ExportObservationsPdfButton>)
            }
        } else {
            if(this.props.activeTab === 3) {
                customCardButtons.map(b => buttons.push(b))
            }
    
            if(this.props.activeTab === 4) {
                buttons.push(<ExportObservationsButton></ExportObservationsButton>)
                buttons.push(<ExportRegistersButton></ExportRegistersButton>)
                buttons.push(<ExportCertificatesButton></ExportCertificatesButton>)
                buttons.push(<ExportObservationsPdfButton></ExportObservationsPdfButton>)
            }
        }

        if (this.props.userRole.edit_team && (this.props.activeTab === 0 || this.props.activeTab === 1)) {
            buttons.push(<AssignUsersButton></AssignUsersButton>);
        }

        if(this.props.userRole.sensitive_data && (this.props.activeTab === 0 || this.props.activeTab === 1)){
            buttons.push(<AddPaymentButton cardsGroupIds={cardsGroupIds}></AddPaymentButton>)
        }

        if (this.props.userRole.mark_as_unfulfilled && (this.props.activeTab === 0 || this.props.activeTab === 1)) {
            buttons.push(<UnfulfilledButton cardsGroupIds={cardsGroupIds}/>);
        }

        if (this.props.userRole.add_card && this.props.activeTab === 2) {
            buttons.push(<GanttChartDatesButton cardsGroupIds={cardsGroupIds}/>);
        }
        
        return {buttons, hasSecondActiveTabPermissions}
    }


    render(){   
        if (!this.props.popUpMenu.show 
            || this.props.selectedCardsGroups === 'none'
            || this.props.selectedCardsGroups.length === 0) return (<div></div>)
        
        const failureCardsGroupIds = checkFailuresSelected(this.props.selectedCardsGroups, this.props.projectData);
        if (failureCardsGroupIds.length > 0) {
            this.loadFailureDescriptions(failureCardsGroupIds);
        }
        let groupedCardsGroupIds = groupCardsGroupIds(this.props, this.props.selectedCardsGroups);
        let title = this.props.selectedCardsGroups.length > 1 ?  _('protocolos seleccionados') : _('protocolo seleccionado');
        let {buttons, hasSecondActiveTabPermissions} = this.getButtonsToRender(this.props.selectedCardsGroups, groupedCardsGroupIds);
        // Necessary when user clicks on second tab from tabsMenu and there are not buttons to render when popUpMenu opens
        if (this.props.activeTab == 2 && !hasSecondActiveTabPermissions) {
            this.props.setActiveTab(1)
        }
        buttons = setButtonPositions(buttons);

        return (
            <div className='popup-menu-layout'>
                <div className="circle-background" ref={ ref => this.background = ref } onClick={ this.handleClosePopup }/>

                { this.props.popUpMenu.expanded ? null :
                <h3 className='popup-menu-title'>{ this.props.selectedCardsGroups.length + ' ' + title }</h3>
                }

                <div className='popup-menu-container'>
                    <CardsGroupsList cardsGroupsByCategory={ groupedCardsGroupIds.byCategory }/>
                    { buttons }
                    <OnStageLogo handleClick={ this.handleAnimationClosePopup }/>
                    <UpButton hasSecondActiveTabPermissions={hasSecondActiveTabPermissions}></UpButton>
                    <DownButton hasSecondActiveTabPermissions={hasSecondActiveTabPermissions}></DownButton>
                    
                </div>

                <MaterialsInfo 
                    popUpMenu={ this.props.popUpMenu } 
                    selectedCardsGroupIds={ this.props.selectedCardsGroups } 
                    projectData={ this.props.projectData }
                />
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        projectData         : state.projectData,
        popup               : state.popup,
        popUpMenu           : state.popUpMenu,
        day                 : state.day,
        cardCategoryIds     : state.filters.cardCategoryIds,
        protocolsIds        : state.filters.protocolIds,
        status              : state.filters.status,
        customcardId        : state.filters.customcardId,
        userRole            : state.userRole,
        selectedCardsGroups : state.selectedCardsGroups,
        qualityProgress     : state.qualityProgress,
        zoneIds             : state.filters.zoneIds,
        editMode            : state.switches.editMode,
        activeTab           : state.activeTab
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        popupChange : popupChange,
        popUpMenuChange : popUpMenuChange,
        selectedCardsGroupsChange : selectedCardsGroupsChange,
        toggleSwitch : toggleSwitch,
        addFirstCardDescription : addFirstCardDescription,
        setActiveTab: setActiveTab
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(PopUpMenu)